import { Routes } from '@angular/router';
import { AboutUsPageComponent } from './about-us/about-us-page/about-us-page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UploadTabComponent } from './patients/dashboard-page/upload-tab/upload-tab.component';
import { PATH_ABOUT_US, PATH_INVALID_CABINET, PATH_PAGE_NOT_FOUND, PATH_UPLOAD } from './global';
import { PATH_LOGIN } from './login/login.global';
import { loginRoutes } from './login/login.routes';
import { patientsRoutes } from './patients/patients.routes';
import { studentsRoutes } from './students/students.routes';
import { medicationsRoutes } from './medications/medications.routes';
import { settingsRoutes } from './settings/settings.routes';
import { knightMedsInstall } from '../environments/deploy_info';
import { releasePagesRoutes } from './knightmeds/release-pages/release-pages.routes';
import { reloadPagesRoutes } from './knightmeds/reload-pages/reload-pages.routes';
import { InvalidCabinetPageComponent } from './knightmeds/invalid-cabinet-page/invalid-cabinet-page.component';

export const appRoutes: Routes = [
  { path: '', redirectTo: PATH_LOGIN, pathMatch: 'full' },
  { path: PATH_ABOUT_US, component: AboutUsPageComponent },
  { path: PATH_PAGE_NOT_FOUND, component: PageNotFoundComponent },
  { path: PATH_UPLOAD, component: UploadTabComponent },
  ...loginRoutes,
  ...patientsRoutes,
  ...studentsRoutes,
  ...medicationsRoutes,
  ...settingsRoutes,
  ...(knightMedsInstall
    ? [
        ...releasePagesRoutes,
        ...reloadPagesRoutes,
        { path: PATH_INVALID_CABINET, component: InvalidCabinetPageComponent },
      ]
    : []),
  { path: '**', redirectTo: PATH_PAGE_NOT_FOUND },
];
